import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import AppContainer from './AppContainer';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { analytics } from './firebase';
import { logEvent } from 'firebase/analytics';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <AppContainer />
  </Provider>
);

if (window.location.pathname.includes("/push-open")) {
  logEvent(analytics, "notification_open");
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Регистрирация SW
serviceWorkerRegistration.register();
